import React from 'react';
import {Card, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import Chip from 'material-ui/Chip';

const styles = {
  card:{
    margin:8,
  },
  cardheader:{
    padding:8,
    paddingBottom:0,
  },
  imgStyle:{
    //height:350,
  },
  maintext:{
    paddingTop:0,
    paddingBottom:0,
  },
  chip: {
    margin: 4,
    backgroundColor:"rgb(240,240,240)"
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
};

export default class ExperienceDashDraw extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  handleExpandChange = (expanded) => {
    this.setState({expanded: expanded});
  };

  handleToggle = (event, toggle) => {
    this.setState({expanded: toggle});
  };

  handleExpand = () => {
    this.setState({expanded: true});
  };

  handleReduce = () => {
    this.setState({expanded: false});
  };

  render() {
    return (
      <Card
        expanded={this.state.expanded}
        onExpandChange={this.handleExpandChange}
        style={styles.card}
      >
        <CardHeader
          title="DashDraw, Sole Developer"
          subtitle="Mobile Game: 2017-2019"
          avatar="images/dashdraw.jpg"
          actAsExpander={true}
          showExpandableButton={this.props.showCarrot}
          style={styles.cardheader}
        />
        <CardText
          style={styles.maintext}
        >

          <div>
            <ul>
              <li>
                Design and development of a mobile game
              </li>
              <div style={styles.wrapper}>
                <Chip style={styles.chip}>
                  HTML/CSS/Javascript
                </Chip>
                <Chip style={styles.chip}>
                  React
                </Chip>
                <Chip style={styles.chip}>
                  Cordova
                </Chip>
                <Chip style={styles.chip}>
                  Material-UI
                </Chip>
                <Chip style={styles.chip}>
                  AdMob
                </Chip>
              </div>
            </ul>

          </div>
        </CardText>
        <CardMedia
          expandable={true}
          overlay={<CardTitle title="DashDraw" subtitle="" />}
        >
          <img
            src="images/dashdraw_levels.jpg" alt=""
            style={styles.imgStyle}
          />
        </CardMedia>
        <CardText expandable={true}>
          <ul>
            <li>DashDraw is a mobile game where the player connects dots as quickly as possible by sketching without colliding with borders</li>
            <li>Cross-platform programming (iOS and Android) using Cordova</li>
          </ul>
        </CardText>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ExperienceDashDraw.js